export default __webpack_public_path__ + "static/marker-e3bc74207979e0f2f44de7b9ba273b85.svg";